import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark" }, [
  /*#__PURE__*/_createTextVNode(" The research proposal "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Reseach study details"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold mb-6 fs-6" }, " Check All Applicable Categories. ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row mb-6 fh-row" }
const _hoisted_9 = { class: "col-lg-5 fv-row" }
const _hoisted_10 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "A new grant/contract")
], -1)
const _hoisted_12 = { class: "col-lg-7 fv-row" }
const _hoisted_13 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "A dissertation or thesis")
], -1)
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-5 fv-row" }
const _hoisted_17 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "An independent study")
], -1)
const _hoisted_19 = { class: "col-lg-7 fv-row" }
const _hoisted_20 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "A graduate research proposal")
], -1)
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-5 fv-row" }
const _hoisted_24 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "A class project")
], -1)
const _hoisted_26 = { class: "col-lg-7 fv-row" }
const _hoisted_27 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "An undergraduate research proposal")
], -1)
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-6 fv-row" }
const _hoisted_31 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "An existing grant")
], -1)
const _hoisted_33 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_34 = { class: "fs-5 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p1",
                  value: "1",
                  modelValue: _ctx.step1.p1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step1.p1) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p2",
                  value: "1",
                  modelValue: _ctx.step1.p2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.p2) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_14
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p3",
                  value: "1",
                  modelValue: _ctx.step1.p3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.p3) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_18
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p4",
                  value: "1",
                  modelValue: _ctx.step1.p4,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.p4) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_21
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p5",
                  value: "1",
                  modelValue: _ctx.step1.p5,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.p5) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_25
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p6",
                  value: "1",
                  modelValue: _ctx.step1.p6,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.p6) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_28
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "p7",
                  value: "1",
                  modelValue: _ctx.step1.p7,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.p7) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_32
              ])
            ])
          ])
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "researchProposals",
          class: "fv-plugins-message-container invalid-feedback"
        }),
        _createElementVNode("div", _hoisted_33, [
          _withDirectives(_createElementVNode("label", _hoisted_34, " If The Proposal Is An Existing Grant, Indicate The Funding Agency ", 512), [
            [_vShow, _ctx.isShowFunding]
          ]),
          _withDirectives(_createVNode(_component_Field, {
            class: "form-control form-control-solid",
            placeholder: "",
            name: "fundingAgency",
            modelValue: _ctx.step1.fundingAgency,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step1.fundingAgency) = $event))
          }, null, 8, ["modelValue"]), [
            [_vShow, _ctx.isShowFunding]
          ]),
          _createVNode(_component_ErrorMessage, {
            name: "fundingAgency",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ])
      ])
    ])
  ]))
}